var React = require('react');

function IconCheckmarkInline (props) {
    return React.createElement("path",props);
}

IconCheckmarkInline.defaultProps = {"d":"M31.6603336,5.36444649 C32.7109362,3.66733425 34.9384112,3.14322709 36.6355384,4.19382038 C38.261952,5.20063895 38.8110649,7.28829098 37.9293276,8.9542036 L37.8061748,9.16898133 L20.8028202,36.6356968 C19.6713252,38.4634804 17.2205149,38.8923593 15.5403428,37.6089725 L15.3500157,37.4532728 L4.88641283,28.2977009 C3.38427155,26.9833389 3.23205579,24.7001226 4.54642941,23.1979946 C5.80365634,21.7611764 7.94732866,21.5594399 9.44596344,22.6948831 L9.64618074,22.8580141 L16.9014163,29.2053915 L31.6603336,5.36444649 Z","transform":"translate(21.000000, 21.000000) rotate(8.000000) translate(-21.000000, -21.000000) "};

module.exports = IconCheckmarkInline;

IconCheckmarkInline.default = IconCheckmarkInline;
